import { config } from './config';

/**
 * 사업자 정보(전자상거래법 표시 사항). 홈페이지 첫 화면·공개 페이지 아래에 나온다.
 * 대표님이 정보를 주면 여기만 채우면 된다. 빈 값은 화면에 나오지 않는다.
 */
export const BUSINESS = {
  name: '도로시프로덕션', // 상호
  ceo: '이의성',      // 대표자
  regNo: '626-02-03220',         // 사업자등록번호
  mailOrderNo: '제2025-충북충주-0977호',   // 통신판매업 신고번호
  address: '충북 충주시 호암수청1로 29', // 사업장 주소
  phone: '010-2309-5502', // 고객센터 전화
  hours: '',         // 고객센터 운영 시간(예: 평일 10:00~18:00)
  email: config.supportEmail,
};
